import { injectScript } from '@dbh/dom';

const injectHotjarScript=async()=>{window.hj=window.hj||function(){// Do not use `arguments` in other cases, in this case we just want to avoid
// babel transpiling the code.
// eslint-disable-next-line prefer-rest-params
window.hj.q=window.hj.q||[],window.hj.q.push(arguments);},window._hjSettings={hjid:959276,hjsv:6};// eslint-disable-next-line no-underscore-dangle
const a="https://static.hotjar.com/c/hotjar-"+window._hjSettings.hjid+".js?sv="+window._hjSettings.hjsv;await injectScript(a);};

export { injectHotjarScript };
